export const scrollToFirstInvalidField = (fieldName: string | null | undefined): void => {
  if (!fieldName) return;

  const fieldElement = document.querySelector(`[data-field-name="${fieldName}"]`);
  fieldElement?.scrollIntoView({
    behavior: "smooth",
    block: "center",
    inline: "nearest",
  });
};
